"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDateTimeField = void 0;
const date_time_field_1 = require("../../../components/date-time-field/date-time-field");
const form_field_1 = require("./form-field");
/**
 * @deprecated
 *
 * Use FormInstantField instead.
 */
exports.FormDateTimeField = form_field_1.formFieldFactory(date_time_field_1.DateTimeField);
//# sourceMappingURL=form-date-time-field.js.map